import { faEye, faFileInvoice, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from 'Common/Loader';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { GetOldGoldPurchaseOrderItemListByBagId, GenerateDeliveryChallan, GetPurchaseOrderRequestList, GenerateEstimatePaymentReceipt, UpdateMayavePurchaseOrderStatus, GeneratePurchaseOrderInvoice } from '../servises';
import CustomStore from 'devextreme/data/custom_store';
import { HttpStatus } from 'modules/core';
import ShowOldGoldRequestModal from './ShowOldGoldRequestModal';
import { toast } from 'react-toastify';
import notistack from 'modules/core/notistack';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess } from 'slices/auth/login/reducer';
import { RootState } from 'slices/app/store/store';
interface ActionButtonsModalProp {
    selectedId: string;
    status: string;
    reloadDataSource(): void;
}

const ActionOldGoldRequest: React.FC<ActionButtonsModalProp> = ({ selectedId, status, reloadDataSource }) => {
    const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showVoucherModal, setShowVoucherModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [selectedAction, setSelectedAction] = useState<null | 'ACCEPTED' | 'REJECTED'>(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showEstimeteModule, setShowEstimeteModule] = useState(false);


    // const dataSource = (): any | undefined => {
    //     return new CustomStore({
    //         key: 'id',
    //         load: async () => {
    //             try {
    //                 const response = await GetOldGoldPurchaseOrderItemListByBagId(selectedId);
    //                 console.log(response);

    //                 return response;
    //             } catch (error) {
    //                 console.error("Data loading error:", error);
    //                 return { data: [], totalCount: 0 };
    //             }
    //         }
    //     });
    // };
    const handleVoucherData = async () => {
        setLoading(true);
        try {
            const response = await GenerateDeliveryChallan(selectedId);
            if (response.status === HttpStatus.Success) {
                setPdfData(response.data);
                setShowVoucherModal(true);
            }
        } catch (error) {
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };

    const [title, setTitle] = useState('');
    const handelEstimateData = async () => {
        setLoading(true);
        try {
            const response = await GenerateEstimatePaymentReceipt(selectedId)
            if (response.status === HttpStatus.Success) {
                setPdfData(response.data);
                setTitle("Estimate receipt")
                setShowEstimeteModule(true)
            }
        } catch (error) {
            console.log('Faild to load Estimate Challan', error);
        } finally {
            setLoading(false);
        }
    }

    const handelFinalInvoice = async () => {
        setLoading(true);
        try {
            const response = await GeneratePurchaseOrderInvoice(selectedId)
            if (response.status === HttpStatus.Success) {
                setPdfData(response.data);
                setTitle("Invoice");
                setShowEstimeteModule(true)
            } else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.notifyFromApi(error)
            console.log('Faild to load final Challan', error);
        } finally {
            setLoading(false);
        }
    }

    const handleAccept = () => {
        setSelectedAction('ACCEPTED');
        setShowConfirmModal(true);
    };

    const handleReject = () => {
        setSelectedAction('REJECTED');
        setShowConfirmModal(true);
    };

    const handleSave = async () => {

        if (!selectedAction) return;

        setLoading(true);
        try {
            const payload = {
                BagId: selectedId,
                Status: selectedAction
            };
            const response = await UpdateMayavePurchaseOrderStatus(payload);
            if (response.status === HttpStatus.Success) {
                console.log('Status updated successfully:', response);
                toast.success('Status updated successfully')
                reloadDataSource()
            }
            else {
                console.error('Failed to update status', response);
            }
            setShowConfirmModal(false);
            setShowApproveModal(false);
            setSelectedAction(null);
        } catch (error) {
            console.error('Error updating status:', error);
        } finally {
            setLoading(false)
        }
    };

    const handleCancelConfirmation = () => {
        setShowConfirmModal(false);
        setSelectedAction(null);
    };


    // const user = useSelector((state: RootState) => state.Login.user);
    // console.log(user)
    const isMainStore = localStorage.getItem('mayavePurityEdit') === 'true';

    const handleClose = () => {
        setShowViewModal(false)
    }

    return (
        <>
            {loading && <Loader />}
            <div className='d-flex align-items-center justify-content-start'>
                <button className='btn btn-sm action-btn' title='View Product' onClick={() => setShowViewModal(true)}>
                    <FontAwesomeIcon icon={faEye} className="ml-2" />
                </button>
                <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={handleVoucherData}>
                    <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
                </button>

                {status?.toLowerCase() == 'INPROGRESS'.toLowerCase() && (
                    <>
                        <button className='btn btn-sm action-btn' title='Estimate receipt'>
                            <FontAwesomeIcon icon={faFilePdf} className='ml-2 text-dangeer' onClick={handelEstimateData} />
                        </button>


                    </>
                )}
                {!isMainStore && status?.toLowerCase() === 'INPROGRESS'.toLowerCase() && (
                    <div className="d-inline">
                        <Button
                            size="sm"
                            variant="light"
                            onClick={() => setShowApproveModal(true)}
                        >
                            Approval
                        </Button>
                    </div>
                )}


                {(status?.toLowerCase() === 'ACCEPTED'.toLowerCase()) && (
                    <>
                        <button className='btn btn-sm action-btn' title='Estimate receipt'>
                            <FontAwesomeIcon icon={faFilePdf} className='ml-2 text-dangeer' onClick={handelEstimateData} />
                        </button>

                        <button className='btn btn-sm action-btn' title=' Invoice'>
                            <FontAwesomeIcon icon={faFileInvoice} onClick={handelFinalInvoice} />
                        </button>
                    </>
                )}

                {status?.toLowerCase() === "REJECTED".toLowerCase() && (
                    <button className='btn btn-sm action-btn' title='Estimate receipt'>
                        <FontAwesomeIcon icon={faFilePdf} className='ml-2 text-dangeer' onClick={handelEstimateData} />
                    </button>
                )}
            </div>


            <Modal size='xl' show={showViewModal} onHide={() => setShowViewModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Old Gold Purchase List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowOldGoldRequestModal selectedId={selectedId as string} handleClose={handleClose} reloadDataSource={reloadDataSource} status={status} />
                </Modal.Body>
            </Modal>

            {/* this is Dilevery Challan Modal */}
            <Modal size='lg' show={showVoucherModal} onHide={() => setShowVoucherModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delivery Challan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>

            {/* this is Estimet Payment Modal */}
            <Modal size='lg' show={showEstimeteModule} onHide={() => setShowEstimeteModule(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>

            {/* Approve Modal */}
            <Modal show={showApproveModal} onHide={() => setShowApproveModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    What would you like to do with <strong>Bag ID: {selectedId}</strong>?
                    <Modal.Footer>
                        <Button className='btn submit-btn' onClick={handleReject}>
                            Reject
                        </Button>
                        <Button className='btn success-btn' onClick={handleAccept}>
                            Accept
                        </Button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>

            <Modal show={showConfirmModal} onHide={handleCancelConfirmation} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to save this entry? Once you save it, you cannot revert back <strong>Action: <span className="text-danger">{selectedAction}</span></strong> Bag ID: <strong>{selectedId}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn add-btn' onClick={handleCancelConfirmation}>
                        Cancel
                    </Button>
                    <Button className='btn submit-btn' onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>


        </>
    );
};
export default ActionOldGoldRequest;